export interface MovimentoPorPeriodoModel {
  data: string;
  sangria: number;
  suprimento: number;
}

export class MovimentoKpisModel {
  totalSangria: number;
  totalSuprimento: number;
  qtdSangrias: number;
  qtdSuprimentos: number;
}

export class MovimentoModel {
  kpis: MovimentoKpisModel;
  porPeriodo: MovimentoPorPeriodoModel[];
}

export function emptyMovimento(): MovimentoModel {
  return {
    kpis: { totalSangria: 0, totalSuprimento: 0, qtdSangrias: 0, qtdSuprimentos: 0 },
    porPeriodo: [],
  };
}
